var map = {
	"./bs_t-3_reflect-stitch_blk.png": 121636,
	"./bs_t-3_reflect-stitch_blu.png": 817098,
	"./bs_t-3_reflect-stitch_cml.png": 798141,
	"./bs_t-3_reflect-stitch_crk.png": 481339,
	"./bs_t-3_reflect-stitch_grn.png": 753586,
	"./bs_t-3_reflect-stitch_lgd.png": 215584,
	"./bs_t-3_reflect-stitch_lsl.png": 292500,
	"./bs_t-3_reflect-stitch_nvy.png": 462636,
	"./bs_t-3_reflect-stitch_orn.png": 863354,
	"./bs_t-3_reflect-stitch_pnk.png": 711616,
	"./bs_t-3_reflect-stitch_ppl.png": 288077,
	"./bs_t-3_reflect-stitch_red.png": 616880,
	"./bs_t-3_reflect-stitch_sax.png": 542085,
	"./bs_t-3_reflect-stitch_wht.png": 164442,
	"./bs_t-3_reflect-stitch_ylw.png": 219539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926024;